/* Static bundle pages (Routines & Sets): real add-to-cart for a fixed list of variants. */
(function () {
  function init(root) {
    if (root.__ba) return; root.__ba = true;
    var btn = root.querySelector('[data-bundle-add]');
    var status = root.querySelector('[data-bundle-status]');
    if (!btn) return;
    var ids = (root.getAttribute('data-ids') || '').split(',').map(Number).filter(Boolean);
    var name = root.getAttribute('data-name') || 'Bundle';
    if (!ids.length) { btn.disabled = true; return; }
    btn.addEventListener('click', function () {
      var label = btn.textContent; btn.disabled = true; btn.textContent = 'Adding…';
      var items = ids.map(function (id) { return { id: id, quantity: 1, properties: { 'Bundle': name } }; });
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () {
          btn.textContent = 'Added ✓';
          if (status) status.textContent = 'Added to your bag.';
          var t = document.querySelector('[data-cart-toggle]'); if (t) t.click();
        })
        .catch(function () {
          btn.textContent = label;
          if (status) status.textContent = 'Sorry, one item in this set just sold out.';
        })
        .then(function () { setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1600); });
    });
  }
  function boot() { document.querySelectorAll('[data-bundle]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
